import React from "react";
import sanitizeHtml from "sanitize-html";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom"
import CloseImage from "../assets/images/close.svg";
import "../assets/css/modal.css";

function JebbitModal(props) {
    const ctEncryptedId = useSelector(state => state.data.ctEncryptedId);
    const campaignId = props.selectedCampaign;

    let renderIFrame = () => {
        const link = `https://nbaloyalty.jebbit.com/${campaignId}?L=Full+Page&user=${ctEncryptedId}`;
        return (
            <iframe
                id="randomid"
                src={link}
                className="jebbit-iframe"
                style={{
                    width: "100%",
                    minHeight: "655px",
                    border: "0px"
                }}
                seamless={true}
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                allowFullScreen={true}
                frameBorder="0"
                title="Jebbit"
                allow="clipboard-read; clipboard-write"
                onLoad={() => {
                    function embedJebbit(t) {
                        function e(t) {
                            var e = "attach" === t ? window.addEventListener : window.removeEventListener;
                            e("DOMContentLoaded", i, !1);
                            e("load", i, !1);
                            e("scroll", i, !1);
                            e("resize", i, !1);
                        }
                        var n = document.querySelector(t);
                        function i() {
                            (function (t) {
                                var e = t.getBoundingClientRect(), n = t.clientHeight / 2, i = t.clientWidth / 2;
                                return e.top >= 0 && e.left >= 0 && e.top <= (window.innerHeight || document.documentElement.clientHeight) - n && e.left <= (window.innerWidth || document.documentElement.clientWidth) - i;
                            })(n) && n.contentWindow && n.contentWindow.postMessage("startJebbitCampaign", "*");
                        }
                        window.addEventListener("message", function (t) {
                            t && ("jebbitSessionCreated" === t.data ? e("remove") : "jebbitCampaignLoaded" === t.data ? i() : t.data && "redirect" === t.data.action && t.data.options && t.data.options.link && (window.location.href = sanitizeHtml(t.data.options.link)));
                        }, !1);
                        e("attach");
                    }
                    embedJebbit(".jebbit-iframe");
                }}>
            </iframe>
        );
    };

    return (
        <div className="modal-container jebbit-container">
            <div className="modal-background">
            </div>
            <div className="modal-dialog jebbit-dialog">
                <div className="modal-header">
                    <Link
                        to={{
                            pathname: "/voting",
                            search: window.location.search.includes("cl=1") ? window.location.search.replace("&cl=1", "") : window.location.search
                        }}
                        className="modal-close"
                        data-track="click"
                        data-id="nba:membership-hub:dismiss"
                        data-section="voting"
                        data-type="dismiss"
                        onClick={() => { props.setShowModal(false) }}>
                        <img alt="close" src={CloseImage} />
                    </Link>
                </div>
                <div className="modal-body jebbitModal">
                    {renderIFrame()}
                </div>
            </div>
        </div>
    );
}

export default JebbitModal;
